import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAnimatedNumber } from '../../hooks/useAnimatedNumber';
import { formatNumber, parseFigure } from '../../utils/numberFormat';

/**
 * Counts a pre-formatted figure up from zero (or from the previous value) and
 * settles on the exact original string. Values that are not a single number
 * ("—", "3 / 12") render as-is; reduced motion shows the final value at once.
 */
const AnimatedFigure: React.FC<{ value: string }> = ({ value }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const parsed = useMemo(() => parseFigure(value, lang), [value, lang]);
  const current = useAnimatedNumber(parsed ? parsed.value : 0);

  if (!parsed || current === parsed.value) return <>{value}</>;
  return (
    <>
      {parsed.prefix}
      {formatNumber(current, lang, parsed.options)}
      {parsed.suffix}
    </>
  );
};

export default AnimatedFigure;
